'use client';

import React from 'react';

/**
 * The center-canvas + optional-pinned-rail grid. Children are the page <main>
 * (which stays the single vertical scroll owner) and the ContextRail. When the
 * rail is not pinned the grid is a single column and the canvas keeps full width,
 * so closing the inspector never leaves dead space.
 */
export default function ShellContentGrid({
  railPinned,
  children,
}: {
  railPinned: boolean;
  children: React.ReactNode;
}) {
  return (
    <div className="shell-content-grid" data-rail-pinned={railPinned ? 'true' : 'false'}>
      {children}
    </div>
  );
}
